import * as React from 'react';
import { Card, Icon, Modal, Button, Row, Col } from 'antd';
import '../../css/Dashboard.scss';
import ActivityList from './ActivityList';
import FilterModal from './filterModal';
import strings from '../../eyeguide-localization/employee/strings.employee';
import Service from '../../service/apolloclient.service';
// import '../../css/ActivityFeed.scss';
// import _ from 'lodash';
const ser = new Service();

interface ActivityFeedProps {
    feedSize: number;
    rosterid: string;
    isCustomer: boolean;
}

interface ActivityFeedState {
    activities: any;
    filterObj: any;
    holdFilter: any;
    dateOrder: string;
    hasMore: boolean;
    filterModalVisible: boolean;
}

export default class ActivityFeed 
    extends React.Component<ActivityFeedProps, ActivityFeedState> {
    constructor(props: any) {
        super(props);
        this.state = {
            activities: [],
            filterObj: {
                username: '',
                dateRange: ['', '']
            },
            holdFilter: {
                username: '',
                dateRange: ['', '']
            },
            dateOrder: 'desc',
            hasMore: true,
            filterModalVisible: false
        };
    }

    componentWillMount() {
        this.loadActivities();
    }

    clearFilters = () => {
        let holdFilter = {
            username: '',
            dateRange: ['', '']
        };
        this.setState(
            { holdFilter },
            () => this.filterActivityList(holdFilter)
        );
    }

    noFiltersApplied = () => {
        let filterObj = this.state.filterObj;
        if (filterObj.username === '' && filterObj.dateRange[0] === '') {
            return true;
        }
        return false;
    }

    render() {
        let filterObj = this.state.filterObj;
        return (
            <React.Fragment>
                <Card style={{margin: '24px 24px'}}>
                    <Icon
                        type="filter"
                        onClick={() => this.toggleFilterModal()}
                        style={{fontSize: 19, float: 'right', cursor: 'pointer'}}
                    />
                    <span hidden={!this.noFiltersApplied()}>
                        {strings.lsNoFilterTxt}
                    </span>
                    <div className="filterContent" hidden={this.noFiltersApplied()}>
                        <Button
                            className="clearFilter"
                            onClick={this.clearFilters}
                        >
                            Clear Filters
                        </Button>
                        <Row className="filterRow" hidden={filterObj.username === ''}>
                            <Col span={8}> Username : </Col>
                            <Col span={12}> {filterObj.username} </Col>
                        </Row>
                        <Row className="filterRow" hidden={filterObj.dateRange[0] === ''}>
                            <Col span={8}> Date Range : </Col>
                            <Col span={12}> {filterObj.dateRange.join(' ... ')} </Col>
                        </Row>
                    </div>
                </Card>
                <Card
                    title={<div style={{display: 'flex', justifyContent: 'space-between'}}>
                        <span>Activity Feed</span>
                        <div>
                            <span>Time</span>&nbsp;&nbsp;
                            <Icon
                                type={this.state.dateOrder === 'asc' ? 'arrow-up' : 'arrow-down'}
                                onClick={this.orderByDate}
                                style={{ cursor: 'pointer' }}
                            />
                        </div>
                    </div>}
                    style={{margin: '24px 24px'}}
                >
                    <ActivityList
                        pageSize={Math.floor(this.props.feedSize / 3)}
                        isCustomer={this.props.isCustomer}
                        activities={this.state.activities}
                        loadActivities={this.loadActivities}
                        hasMore={this.state.hasMore}
                        filterObj={this.state.filterObj}
                    />
                </Card>
                <Modal
                    className="modal"
                    title="Filter Activities"
                    visible={this.state.filterModalVisible}
                    okText={strings.lsFilterTxt}
                    onOk={() => this.filterActivityList(this.state.holdFilter)}
                    onCancel={this.toggleFilterModal}
                    width={750}
                    bodyStyle={{ padding: 0 }}
                    maskClosable={false}
                    closable={false}
                    destroyOnClose={true}
                >
                    <FilterModal
                        filterObj={this.state.holdFilter}
                        handleInputChange={this.handleInputChange}
                        handleDateRange={this.handleDateRange}
                    />
                </Modal>
            </React.Fragment>
        );
    }

    orderByDate = () => {
        let dateOrder = this.state.dateOrder;
        if (dateOrder === 'asc') {
            dateOrder = 'desc';
        } else {
            dateOrder = 'asc';
        }
        this.setState(
            { dateOrder },
            () => this.filterActivityList(this.state.filterObj)
        );
    }

    filterActivityList = (filterObj) => {
        let newFilter = {
            ...filterObj,
            dateOrder: this.state.dateOrder,
            rosterid: this.props.rosterid
        };
        console.log('filter', newFilter);
        let lastid: any;
        if (this.state.dateOrder === 'desc') {
            let today = new Date();
            today.setDate(today.getDate() + 1);
            lastid = today.toISOString().split('T')[0];
        } else {
            lastid = '2000-01-01 00:00:00';
        }
        ser.getActivityFeed(this.props.feedSize, lastid, newFilter)
            .then((res: any) => {
                this.setState({
                    activities: res.slice(),
                    hasMore: res.length === this.props.feedSize,
                    filterModalVisible: false,
                    filterObj
                });
            });
    }

    handleInputChange = (e) => {
        let holdFilter = this.state.holdFilter;
        holdFilter.username = e.target.value;
        this.setState({ holdFilter });
    }

    handleDateRange = (date: any, dateString: any) => {
        console.log('date range', dateString);
        let holdFilter = this.state.holdFilter;
        holdFilter.dateRange = dateString;
        this.setState({ holdFilter });
    }

    toggleFilterModal = () => {
        this.setState({
            filterModalVisible: !this.state.filterModalVisible
        });
    }

    /**
     * Load next activities from API
     */
    loadActivities = () => {
        let activities = this.state.activities.slice();
        let lastid: any;
        if (activities.length > 0) {
            lastid = activities[activities.length - 1].time;
        } else {
            let today = new Date();
            lastid = today.toISOString().split('T')[0] + ' 23:59:59';
        }
        let newFilter = {
            ...this.state.filterObj,
            dateOrder: this.state.dateOrder,
            rosterid: this.props.rosterid
        };
        console.log('filter', newFilter);
        ser.getActivityFeed(this.props.feedSize, lastid, newFilter)
            .then((res: any) => {
                activities.push(...res);
                this.setState({
                    activities: activities,
                    hasMore: res.length > 0 && res.length === this.props.feedSize
                });
            });
    }
}


// WEBPACK FOOTER //
// ./src/components/activityFeed/ActivityFeed.tsx